// src/api/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: "/api/v1",
  timeout: 3000000,
});

// interceptor para agregar token en cada request
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token"); // ⚡ siempre tomamos de sessionStorage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Si el servidor responde 401 por la SESIÓN (token inválido o vencido, usuario inexistente, no autenticado),
// se limpia la sesión de esta pestaña y se vuelve al inicio de sesión. Otros 401 no se tocan.
let _redirigiendoALogin = false;
api.interceptors.response.use(
  (respuesta) => respuesta,
  (error) => {
    const estado = error && error.response ? error.response.status : null;
    const url = (error && error.config && error.config.url) || '';
    const detalle = String((error && error.response && error.response.data && error.response.data.detail) || '');
    const esLogin = /login/i.test(url);
    const esSesion = /token|usuario no encontrado|no autenticado|not authenticated|credentials/i.test(detalle);
    if (estado === 401 && esSesion && !esLogin && !_redirigiendoALogin && window.location.pathname !== '/login') {
      _redirigiendoALogin = true;
      try { sessionStorage.clear(); } catch (e) { /* sin almacenamiento disponible */ }
      alert('Tu sesión venció o ya no es válida. Inicia sesión de nuevo.');
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export default api;
